module.exports = __webpack_public_path__ + "static/media/youxuan@3x.3ef23ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/youxuan@3x.png
// module id = 564
// module chunks = 6